export const assetMaintainenaceComparisonViewOptions = [
  {
    name: 'Maintenance Cost',
    value: 'maintenance_cost',
  },
  {
    name: 'Maintenance Count',
    value: 'maintenance_count',
  },
  {
    name: 'Down Time Hours',
    value: 'downtime_hours',
  },
];
